var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1306",
    "data-name": "Grupo 1306",
    transform: "translate(-1323 -53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_309",
    "data-name": "Elipse 309",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(1323 53)",
    fill: "#f4f2f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1298",
    "data-name": "Grupo 1298",
    transform: "translate(-221.28 -624.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1296",
    "data-name": "Grupo 1296",
    transform: "translate(1556.132 687.773)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_307",
    "data-name": "Elipse 307",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(0.148 11)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_137",
    "data-name": "L\\xEDnea 137",
    y1: 6,
    transform: "translate(4.148 19)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_138",
    "data-name": "L\\xEDnea 138",
    y1: 11,
    transform: "translate(4.148 0)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1297",
    "data-name": "Grupo 1297",
    transform: "translate(1569.095 687.773)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_308",
    "data-name": "Elipse 308",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(0.185 6)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_139",
    "data-name": "L\\xEDnea 139",
    y1: 11,
    transform: "translate(4.185 14)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_140",
    "data-name": "L\\xEDnea 140",
    y1: 6,
    transform: "translate(4.185 0)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedFilter);
export default __webpack_public_path__ + "static/media/advancedFilter.15ce5ff7ae3984c588dbc45e52f861fa.svg";
export { ForwardRef as ReactComponent };